import { render } from "./VettingSummary.vue?vue&type=template&id=d8af3a02&scoped=true"
import script from "./VettingSummary.vue?vue&type=script&lang=js"
export * from "./VettingSummary.vue?vue&type=script&lang=js"

import "./VettingSummary.vue?vue&type=style&index=0&id=d8af3a02&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8af3a02"]])

export default __exports__